var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('u-card-border-bottom', _vm._b({
    staticClass: "card-tertiary v-card--none-active-bg"
  }, 'u-card-border-bottom', _vm.$attrs, false), [_vm.innerClass || _vm.cardInnerSize ? [_c('div', {
    staticClass: "card-inner",
    class: [_vm.innerClass, _vm.cardInnerSize]
  }, [_vm._t("default")], 2)] : [_vm._t("default")]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }